import { useState, useEffect } from "react";

import lucrare1 from "../assets/Lucrari/lucrare1.jpg";
import lucrare2 from "../assets/Lucrari/lucrare2.jpg";
import lucrare3 from "../assets/Lucrari/lucrare3.jpg";
import lucrare4 from "../assets/Lucrari/lucrare4.jpg";
import lucrare5 from "../assets/Lucrari/lucrare5.jpg";
import lucrare6 from "../assets/Lucrari/lucrare6.jpeg";
import lucrare7 from "../assets/Lucrari/lucrare7.jpeg";
import lucrare8 from "../assets/Lucrari/lucrare8.jpeg";
import lucrare9 from "../assets/Lucrari/lucrare9.jpg";
import lucrare10 from "../assets/Lucrari/lucrare10.jpg";
import lucrare11 from "../assets/Lucrari/lucrare11.jpg";
import lucrare12 from "../assets/Lucrari/lucrare12.jpg";
import lucrare13 from "../assets/Lucrari/lucrare13.jpg";
import lucrare14 from "../assets/Lucrari/lucrare14.jpg";
import lucrare15 from "../assets/Lucrari/lucrare15.jpeg";
import lucrare16 from "../assets/Lucrari/lucrare16.jpeg";
import lucrare17 from "../assets/Lucrari/lucrare17.jpeg";


const images = [lucrare1, lucrare2, lucrare3, lucrare4, lucrare5, lucrare6, lucrare7, lucrare8, lucrare9, lucrare10, lucrare11, lucrare12 , lucrare13 , lucrare14 , lucrare15 , lucrare16 , lucrare17];

const GalerieFoto = () => {
  const [activeImg, setActiveImg] = useState(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (activeImg) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [activeImg]);

  const openImage = (img) => {
    const centerTop =
      window.scrollY + window.innerHeight / 2;
    const centerLeft =
      window.innerWidth / 2;

    setPosition({
      top: centerTop,
      left: centerLeft,
    });

    setActiveImg(img);
  };

  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-10">
        Galerie Foto
      </h1>

      <p className="text-center text-gray-600 max-w-2xl mx-auto mb-12">
        Imagini din cabinetul nostru și lucrări realizate cu grijă și profesionalism.
      </p>

      {/* GRID */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {images.map((img, index) => (
          <button
            key={index}
            onClick={() => openImage(img)}
            className="overflow-hidden rounded-xl shadow-md transition hover:scale-105"
          >
            <img
              src={img}
              alt={`Lucrare ${index + 1}`}
              className="w-full h-64 object-cover"
            />
          </button>
        ))}
      </div>

      {/* MODAL */}
      {activeImg && (
        <>
          <div
            className="fixed inset-0 z-40 bg-black/80"
            onClick={() => setActiveImg(null)}
          />

<div
  style={{
    top: position.top,
    left: position.left,
    transform: "translate(-50%, -50%)",
  }}
  className="absolute z-50"
  onClick={(e) => e.stopPropagation()}
>
  {/* BUTON X */}
  <button
    onClick={() => setActiveImg(null)}
    className="
      absolute
      -top-4
      -right-4
      z-50
      w-10
      h-10
      rounded-full
      bg-white
      text-gray-800
      flex
      items-center
      justify-center
      shadow-lg
      hover:bg-gray-100
      active:scale-95
    "
    aria-label="Închide"
  >
    ✕
  </button>

  {/* IMAGINE */}
  <img
    src={activeImg}
    alt="Imagine mărită"
    className="
      max-w-[95vw]
      max-h-[95vh]
      object-contain
      rounded-xl
      shadow-2xl
    "
  />
</div>

        </>
      )}
    </div>
  );
};

export default GalerieFoto;
